type ParticipantLayoutOptions = {
  bVideoOn: boolean;
  isMinimizeOrMobile: boolean;
  isMobile: boolean;
  participantsCount: number;
};

/** Class names for a single participant item in the participants strip. */
export const getParticipantItemClassNames = ({
  bVideoOn,
  isMinimizeOrMobile,
  isMobile,
  participantsCount
}: ParticipantLayoutOptions): { [key: string]: boolean } => ({
  'aspect-video': bVideoOn,
  'hidden!': isMinimizeOrMobile,
  [isMobile ? 'w-[120px]' : 'w-[150px]']: bVideoOn || participantsCount > 1,
  'p-[18px]': !bVideoOn && participantsCount === 1
});
